const PAGES = {
  v3: {
    ArchiveElementsPage: require(`./v3/elements/archive/ArchiveElementsPage`)
      .default,
    ShareElementPage: require(`./v3/elements/share/ShareElementPage`).default,
    EditElementPage: require(`./v3/elements/edit/EditElementPage`).default,
    ReflectionEditPage: require(`./v3/reflection/edit/ReflectionEditPage`)
      .default,
    EditRoutinePage: require(`./v3/routines/edit/EditRoutinePage`).default,
    ElementsPage: require(`./v3/elements/ElementsPage`).default,
    EnabledUsersPage: require(`./v3/more/users/EnabledUsersPage`).default,
    Footer: require(`./v3/common/footer/bar`).default,
    GetStartedPage: require(`./v3/more/GetStartedPage`).default,
    Goal: require(`./v3/resolution/goals/Goal`).default,
    Header: require(`./v3/common/header/index`).default,
    HelpPage: require(`./v3/more/HelpPage`).default,
    HomePage: require(`./v3/home/HomePage`).default,
    ImpersonatePage: require(`./v3/more/ImpersonatePage`).default,
    
    IntegrationsMappingPage: require(`./v3/integrations/mapping/IntegrationsMappingPage`).default,
    IntegrationsMappingDone: require(`./v3/integrations/mapping/IntegrationsMappingDone`).default,
    IntegrationsPageV2: require(`./v3/integrations/IntegrationsPageV2`).default,
    IntegrationsOnboardingPage: require(`./v3/integrations/onboarding/IntegrationsOnboardingPage`).default,
    DesktopSyncPage: require(`./v3/integrations/home/desktop/DesktopSyncPage`).default,
    CalendarSyncPage: require(`./v3/integrations/home/calendar/CalendarSyncPage`).default,
    HealthSyncPage: require(`./v3/integrations/home/health/HealthSyncPage`).default,
    ChromeSyncPage: require(`./v3/integrations/home/chrome/ChromeSyncPage`).default,
    SlackSyncPage: require(`./v3/integrations/home/slack/SlackSyncPage`).default,

    DashboardPage: require(`./v3/dashboard/DashboardPage`).default,

    InviteFriendsPage: require(`./v3/more/InviteFriendsPage`).default,
    KnowledgeBasePage: require(`./v3/home/gated-product/KnowledgeBasePage`).default,
    LastWeekPage: require(`./v3/onboarding/LastWeekPage`).default,
    MyReportsPage: require(`./v3/reports/list/MyReportsPage`).default,
    SnoozedCardsPage: require(`./v3/cards/SnoozedCardsPage`).default,
    PageMore: require(`./v3/more/PageMore`).default,
    PaymentsPage: require(`./v3/pay/PaymentsPage`).default,
    ReflectionPage: require(`./v3/reflection/ReflectionPage`).default,
    ReportsPage: require(`./v3/reports/ReportsPage`).default,
    ResolutionDetailPage: require(`./v3/resolution/edit/ResolutionDetailPage`).default,
    ResolutionGemsPage: require(`./v3/resolution/ResolutionGemsPage`).default,
    ResolutionPage: require(`./v3/resolution/ResolutionPage`).default,
    RoutinesPage: require(`./v3/routines/RoutinesPage`).default,
    SettingsPage: require(`./v3/more/SettingsPage`).default,
    TestingPage: require(`./v3/more/TestingPage`).default,
    TrackDetailsPage: require(`./v3/journal/edit/TrackDetailPage`).default,
    TrackHomePage: require(`./v3/journal/TrackHomePage`).default,

    CoachingRoomPage: require(`./v3/more/coaching/CoachingRoomPage`).default,
  },
};

export const ComponentsFactory = (pageName, version = "v3") => {
  return PAGES[version][pageName];
};

export default ComponentsFactory;
